import AuthProvider from "../services/authProvider";
import React from 'react';
import '../index.css';
//import reportWebVitals from '../reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import ErrorPage from '../pages/error-page';
import { action as searchDestinationAction } from '../components/searchDestination'
import PageSchedule from '../pages/schedule';
import { loader as tripProfileLoader, action as tripProfileAction} from '../pages/travelPreferences'
import { loader as rateActivitiesLoader } from '../pages/rateActivities'
import { loader as activitiesListLoader } from '../pages/activitiesList'
import RateActivities from '../pages/rateActivities';
import TravelPreferences from '../pages/travelPreferences';
import ActivitiesList from '../pages/activitiesList';
import * as Sentry from "@sentry/react";
import ReactGA from 'react-ga';
import PageMapSchedule from '../pages/map';
import TripSchedule, { loader as scheduleLoader } from '../pages/tripSchedule';
import TripPlanPage from '../pages/tripPlanPage';
import Hotjar from '@hotjar/browser';
import Layout from "./Layout";


// Analytics
if(import.meta.env.PROD) {
  ReactGA.initialize([
    {
      trackingId: `${import.meta.env.PUBLIC_GOOGLE_ANALYTICS}`,
      gaOptions: {
        name: 'analytics_tracker'
      }
    },
    {
      trackingId: `${import.meta.env.PUBLIC_GOOGLE_ANALYTICS_ADS}`,
      gaOptions: {
        name: 'ads_tracker',
      },
      
    }
  ])
}

if (import.meta.env.REACT_APP_MOCK === 'true') {
  const { worker } = require('../mocks/browser')
  worker.start({
    onUnhandledRequest: 'bypass',
  })
}

const router = createBrowserRouter([
  {
    path: "/trip-planner",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '',
        element: <TripPlanPage />,
        action: searchDestinationAction,
      },
      {
        path: ':tripId/trip-profile',
        element: <TravelPreferences />,
        loader: tripProfileLoader,
        action: tripProfileAction
      },
      {
        path: ':tripId/rate-activities',
        element: <RateActivities />,
        loader: rateActivitiesLoader, 
      },
      {
        path: ':tripId/activities',
        element: <ActivitiesList />,
        loader: activitiesListLoader, 
      },
      {
        path: ":tripId/plan",
        element: <TripSchedule />,
        loader: scheduleLoader,
        children: [
          {
            path: "schedule",
            element: <PageSchedule />,
            loader: scheduleLoader,
          },
          {
            path: "map",
            element: <PageMapSchedule />,
            loader: scheduleLoader,
          },
        ]
      },
    ],
  },
]);

{import.meta.env.PROD &&
  Sentry.init({
    dsn: "https://1ad1ee235ab80b8eea38454c910e4e7d@o4506771326435328.ingest.sentry.io/4506805009580032",
    integrations: [
      // Tracing Origins are required so that Google Analytics does not through a Cors error.
      // https://github.com/getsentry/sentry-javascript/issues/5868
      Sentry.browserTracingIntegration({
        tracingOrigins: ['/^https:\/\/explra.com/', '/^https:\/\/api.explra.com/',]
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.8, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // Enabling this will trigger CORS issues, adds `baggage` header
    //tracePropagationTargets: ["localhost", /^https:\/\/api\.explra\.com/],
    // Session Replay
    replaysSessionSampleRate: 0.8, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  const siteId = 4979481;
  const hotjarVersion = 6;
  Hotjar.init(siteId, hotjarVersion);
}

export const App = () => {

  return (
    <React.StrictMode>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </React.StrictMode>
  );
};